export const downloadDocumentFile = async (url: string, filename: string) => {
  const token =
    localStorage.getItem("jwtToken") || sessionStorage.getItem("jwtToken");

  const headers: HeadersInit = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    headers,
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error("Impossible de télécharger le fichier");
  }

  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = blobUrl;
  link.download = filename || "document";
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(blobUrl);
};
